<script>
import ConversationCard from 'dashboard/components/widgets/conversation/ConversationCard.vue';
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

export default {
  components: {
    ConversationCard,
    Spinner,
  },
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  computed: {
    conversations() {
      return this.$store.getters['contactConversations/getContactConversation'](
        this.contactId
      );
    },
    previousConversations() {
      return this.conversations.filter(
        conversation => conversation.id !== Number(this.conversationId)
      );
    },
    hasMoreConversations() {
      return this.$store.getters[
        'contactConversations/getHasMoreConversations'
      ](this.contactId);
    },
    ...mapGetters({
      uiFlags: 'contactConversations/getUIFlags',
    }),
  },
  watch: {
    contactId(newContactId, prevContactId) {
      if (newContactId && newContactId !== prevContactId) {
        this.$store.dispatch('contactConversations/get', newContactId);
      }
    },
    'previousConversations.length'() {
      this.$nextTick(this.observeTrigger);
    },
  },
  mounted() {
    this.$store.dispatch('contactConversations/get', this.contactId);
    this.setupObserver();
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    setupObserver() {
      this.observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this.loadMore();
          }
        },
        { threshold: 1.0 }
      );
      this.observeTrigger();
    },
    observeTrigger() {
      if (this.observer && this.$refs.loadMoreTrigger) {
        this.observer.observe(this.$refs.loadMoreTrigger);
      }
    },
    loadMore() {
      if (!this.hasMoreConversations || this.uiFlags.isFetchingList) return;
      this.$store.dispatch(
        'contactConversations/fetchPrevious',
        this.contactId
      );
    },
  },
};
</script>

<template>
  <div v-if="!uiFlags.isFetching" class="">
    <div v-if="!previousConversations.length" class="no-label-message px-4 p-3">
      <span>
        {{ $t('CONTACT_PANEL.CONVERSATIONS.NO_RECORDS_FOUND') }}
      </span>
    </div>
    <div v-else class="contact-conversation--list">
      <ConversationCard
        v-for="conversation in previousConversations"
        :key="conversation.id"
        :chat="conversation"
        :hide-inbox-name="false"
        hide-thumbnail
        enable-context-menu
        compact
        show-conversation-id
        :allowed-context-menu-options="['open-new-tab', 'copy-link']"
      />
      <div ref="loadMoreTrigger" class="h-px w-full" />
      <div
        v-if="uiFlags.isFetchingList"
        class="flex items-center justify-center py-3"
      >
        <Spinner />
      </div>
    </div>
  </div>
  <div v-else class="flex items-center justify-center py-5">
    <Spinner />
  </div>
</template>

<style lang="scss" scoped>
.no-label-message {
  @apply text-n-slate-11 mb-4;
}
</style>
